// Form validation for Company contact form - MSP Configuration
import { plaintextValidator } from '../fields';

const config = { mandatory: true };

const customDomainChecker = {
  customDomain: {
    regexChecker: {
      regex: /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,63}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/i,
      field: 'Portal URL'
    },
    equality: {
      attribute: 'portalDomain',
      message: '^Custom Domain should be different from Portal URL',
      comparator: (v1, v2) => {
        if (v1 === v2) {
          return false;
        }
        return true;
      }
    }
  }
};

export default (mandateCname) =>
  mandateCname
    ? {
        name: plaintextValidator(config),
        ...customDomainChecker
      }
    : { name: plaintextValidator(config) };
